export default __webpack_public_path__ + "static/media/nft_2.06e9ad57.jfif";